import axios from "axios";
import FileSaver from "file-saver";

export function getDeep(obj, ...props) {
    let prop = props.shift();
    if (obj[prop]) {
        if (props.length) {
            return getDeep(obj[prop], ...props);
        }
    }
    return obj[prop];
}

export function scrollToElem(elem) {
    if (elem) {
        window.scrollTo(0, elem.offsetTop + elem.offsetParent.offsetTop);
    }
}

export function smoothScrollToTop(duration) {
    const startingY = window.pageYOffset;
    const diff = 0 - startingY;
    let start;

    window.requestAnimationFrame(function step(timestamp) {
        if (!start) start = timestamp;
        const time = timestamp - start;
        const percent = Math.min(time / duration, 1);

        window.scrollTo(0, startingY + diff * percent);

        if (time < duration) {
            window.requestAnimationFrame(step);
        }
    });
}

export function downloadFile(link, filename = "") {
    return new Promise((resolve, reject) => {
        axios({
            url: link,
            method: "GET",
            responseType: "blob",
            headers: {
                Accept: "*/*"
            }
        })
            .then((response) => {
                responseToDownload(response, filename);
                resolve(response);
            })
            .catch((error) => {
                console.log(error);
                reject(error);
            });
    });
}

export function responseToDownload(response, filename = "") {
    if (filename === "") {
        if (response.headers["x-filename"]) {
            filename = response.headers["x-filename"];
        } else if (response.headers["content-disposition"]) {
            filename = response.headers["content-disposition"].split("filename=").pop();
        }
    }
    FileSaver.saveAs(response.data, filename, { type: response.headers["content-type"] });
}

export function downloadPublicFile(filename = "") {
    window.open("/" + filename, "_blank");
}

export function getCountryData(code = "") {
    const countries = {
        NL: "Nederland",
        BE: "België",
        DE: "Duitsland",
        FR: "Frankrijk",
        PT: "Portugal",
        SR: "Suriname",
        AW: "Aruba",
        BQ: "Bonaire, Sint Eustatius and Saba",
        CW: "Curaçao",
        SX: "Sint Maarten"
    };

    if (code === "") {
        return countries;
    } else if (countries[code] !== undefined) {
        return countries[code];
    } else {
        return "Landcode onbekend: " + code;
    }
}
